import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { API_BASE_URL } from 'redux/constants'
import { Image_BASE_URL } from 'redux/constants'
import { verifyOtpApi } from 'services/Sys-ConfigServices'


function useAuth() {

	const dispatch = useDispatch()

	const navigate = useNavigate()

	const query = useQuery()

	const { token, signedIn } = useSelector((state) => state.auth.session)

	const signIn = async ({ userName, otp, resp }) => {

		try {
			if (resp.token) {
				if (resp.status) {
					dispatch(onSignInSuccess(resp))
					
					if (resp.data1) {
						dispatch(setUser({
							id: resp.data1.id,
							avatar: resp.data1.image,
							userName: resp.data1.userName,
							authority: [resp.data1.userType],
							isAdministrator: !!resp.data1.isAdministrator,
							email: resp.data1.email,
							authType: resp.message,
							token: resp.token

						}))

						localStorage.setItem("authType", JSON.stringify(resp.data1.authType));
						localStorage.setItem("User_Info", JSON.stringify(resp.data1.id));
						localStorage.setItem("User_Full_Info", JSON.stringify(resp.data1));
						localStorage.setItem("Payment_Collect", JSON.stringify(resp.data));

					}

					const redirectUrl = query.get(REDIRECT_URL_KEY)
					navigate("/dashboard")
					return {
						status: 'success',
						message: ''
					}
				}
				else {
					return {
						status: 'failed',
						message: resp.message
					}
				}
			}
			else {
				var resp = await verifyOtpApi(userName, otp);
				if (resp.status) {
					dispatch(onSignInSuccess(resp))
					if (resp.data1) {
						debugger	
						dispatch(setUser({
							id: resp.data1.id,
							avatar: resp.data1.image,
							userName: resp.data1.userName,
							authority: [resp.data1.userType],
							isAdministrator: !!resp.data1.isAdministrator,
							email: resp.data1.email,
							authType: resp.data1.authType,

						}))

						localStorage.setItem("authType", JSON.stringify(resp.data1.authType));
						localStorage.setItem("User_Info", JSON.stringify(resp.data1.id));
						localStorage.setItem("User_Full_Info", JSON.stringify(resp.data1));
						localStorage.setItem("Payment_Collect", JSON.stringify(resp.data));

					}

					const redirectUrl = query.get(REDIRECT_URL_KEY)
					navigate("/dashboard")
					return {
						status: 'success',
						message: ''
					}
				}
				else {
					return {
						status: 'failed',
						message: resp.message
					}
				}
			}

		} catch (errors) {
			return {
				status: 'failed',
				message: errors?.response?.data?.message || errors.toString()
			}
		}
	}

	const handleSignOut = () => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
		localStorage.clear('items')
		window.location.reload()
	}

	const signOut = async () => {
		try {
			await apiSignOut()
			handleSignOut()
		} catch (errors) {
			handleSignOut()
		}
	}

	return {
		authenticated: token && signedIn,
		signIn,
		signOut
	}
}

export default useAuth